/**
 * Sentry test endpoint: GET /api/sentry-example-api
 * Ported from dashboard/app/api/sentry-example-api/route.ts.
 */
import { createFileRoute } from '@tanstack/react-router'
import { createServerFn } from '@tanstack/react-start'

class SentryExampleAPIError extends Error {
  constructor(message: string | undefined) {
    super(message)
    this.name = 'SentryExampleAPIError'
  }
}

const triggerSentryError = createServerFn({ method: 'GET' }).handler(async () => {
  throw new SentryExampleAPIError(
    'This error is raised on the backend called by the example page.',
  )
})

export const Route = createFileRoute('/api/sentry-example-api')({
  loader: () => triggerSentryError(),
  component: () => null,
})
